import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { Quote, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import { MessageHandler } from '@sm360/widget-commons-forms';

import GarageCTA from 'commons-garage/components/GarageCTA/GarageCTA.jsx';
import GarageViewTabSlide from 'commons-garage/components/Garage/GarageViewTabSlide.jsx';

const LoadedGarage = ({
    isNewEnabled,
    isUsedEnabled,
    usedUrl,
    tradeInAmount,
    tradeInTaxCredits,
    quotes,
    deleteQuote,
    isReservationMode,
}) => {
    const garageVehicle =
        quotes.length > 0 &&
        quotes.map((quote) => {
            return (
                <GarageViewTabSlide
                    key={quote.id}
                    quote={quote}
                    deleteQuote={deleteQuote}
                    isReservationMode={isReservationMode}
                />
            );
        });

    let tradeInAmountParam;
    if (tradeInAmount && tradeInTaxCredits) {
        tradeInAmountParam = {
            tradeInAmount: LocaleService.l(tradeInAmount, CurrencyFormats.CURRENCY_0),
            taxCreditsAmount: LocaleService.l(tradeInTaxCredits, CurrencyFormats.CURRENCY_2),
            tradeInWithTaxCredits: LocaleService.l(tradeInAmount + tradeInTaxCredits, CurrencyFormats.CURRENCY_2),
        };
    }

    let titleLoaded;
    if (quotes.length > 1) {
        titleLoaded = LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.TITLE_LOADED_PLURIAL', {
            vehicle: quotes.length,
        });
    } else {
        titleLoaded = LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.TITLE_LOADED');
    }

    return (
        <div className="loaded-garage">
            {isReservationMode ? (
                <div className="reservation_title">
                    <h3 className="sr-subtitle-2">
                        {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.RESERVE.TITLE')}
                    </h3>
                    <p>{LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.RESERVE.DEPOSIT')}</p>
                </div>
            ) : (
                <h3 className="sr-subtitle-2">{titleLoaded}</h3>
            )}
            {tradeInAmount && (
                <MessageHandler
                    code="warning"
                    messageIcon="icon-Warning"
                    canCloseElement={false}
                    body={
                        <p>
                            {LocaleService.t(
                                'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.AMOUNT',
                                tradeInAmountParam
                            )}
                        </p>
                    }
                />
            )}
            {garageVehicle}
            {!isReservationMode && (
                <GarageCTA isNewEnabled={isNewEnabled} isUsedEnabled={isUsedEnabled} usedUrl={usedUrl} />
            )}
        </div>
    );
};

LoadedGarage.displayName = 'LoadedGarage';

LoadedGarage.propTypes = {
    quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteModel)).isRequired,
    deleteQuote: PropTypes.func.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    tradeInTaxCredits: PropTypes.number.isRequired,
    isReservationMode: PropTypes.bool.isRequired,
};

export default LoadedGarage;



// WEBPACK FOOTER //
// ./src/components/LoadedGarage/LoadedGarage.jsx